import { render, staticRenderFns } from "./UserRole.vue?vue&type=template&id=f3736084&scoped=true&"
import script from "./UserRole.vue?vue&type=script&lang=ts&"
export * from "./UserRole.vue?vue&type=script&lang=ts&"
import style0 from "./UserRole.vue?vue&type=style&index=0&id=f3736084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3736084",
  null
  
)

export default component.exports